<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <form-section
      :title="$t('Profiles_Overview_Title_FeaturedAttributes')"
      v-loading="loading"
    >
      <template slot="controls">
        <el-button
          v-if="model.length && canReadPersonalData && notConsentRole"
          @click="dialogVisible = true"
          icon="el-icon-setting"
          type="primary"
          plain
        >
          {{ $t('Profiles_Button_EditFeaturedData') }}
        </el-button>
      </template>

      <div v-if="visibleGroups.length">
        <div v-for="(block, blockIndex) in visibleGroups" :key="blockIndex">
          <div class="block-title">
            {{ block.group_name }}
          </div>
          <div class="block-container">
            <el-row>
              <el-col
                v-for="(item, index) in block.attributes"
                :key="index"
                :span="12"
              >
                <div>
                  <span class="item-field-title">{{ item }}</span>
                  <overflow-tooltip
                    v-if="attributes && item && canReadPersonalData"
                    :value="formatValue(getValue(item))"
                  />
                  <span style="line-height: 28px" v-else>*********</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <div :class="getFeaturedAttributesClass" v-else>
        <span v-if="canReadPersonalData && notConsentRole">
          {{ $t('Profiles_Overview_Text_AddAttributesToFeature') }}
        </span>
        <el-button
          @click="dialogVisible = true"
          icon="el-icon-circle-plus-outline"
          type="primary"
          v-if="canReadPersonalData && notConsentRole"
        >
          {{ $t('Profiles_Button_EditFeaturedData') }}
        </el-button>
      </div>
    </form-section>

    <featured-attributes-dialog
      v-if="dialogVisible"
      :profile-id="profileId"
      :visible.sync="dialogVisible"
      @updated="updateModel"
    />
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import FormSection from '@/common/components/form/FormSection'
import OverflowTooltip from '@/common/components/form/OverflowTooltip'
import { projectEndpoint } from '@/core/helpers'
import FeaturedAttributesDialog from '@/modules/profiles/components/FeaturedAttributesDialog'

export default {
  name: 'FeaturedAttributes',

  components: {
    FeaturedAttributesDialog,
    RestPage,
    FormSection,
    OverflowTooltip
  },

  props: {
    profileId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      model: [],
      attributes: [],
      aggregates: [],
      loading: false,
      dialogVisible: false
    }
  },

  computed: {
    fetchEndpoint() {
      return [
        this.fetchFeaturedAttributesEndpoint,
        this.fetchAttributesEndpoint,
        this.fetchAggregatesEndpoint
      ]
    },

    fetchFeaturedAttributesEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `featured-attributes`,
        handler: data => {
          this.model = data
          this.model.sort((a, b) => a.group_order - b.group_order)
        }
      })
    },

    fetchAttributesEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `profiles/${this.profileId}/attributes?pagination=0`,
        handler: data => {
          this.attributes = data
        }
      })
    },

    fetchAggregatesEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `profiles/${this.profileId}/aggregates?pagination=0`,
        handler: data => {
          this.aggregates = data
        }
      })
    },

    visibleGroups() {
      return this.model.filter(group => {
        return group.attributes && group.attributes.length
      })
    },

    canReadPersonalData() {
      return this.$can('UserPersonalData::Read')
    },

    notConsentRole() {
      return (
        !this.$isRole('consent-admin') &&
        !this.$isRole('consent-customer-service-agent')
      )
    },

    getFeaturedAttributesClass() {
      return this.canReadPersonalData ? 'select-attributes-box' : 'empty-box'
    }
  },

  methods: {
    getValue(key) {
      if (this.attributes) {
        let attr = this.attributes.find(item => {
          return item.name === key
        })

        if (attr) {
          return attr.value
        }
      }

      if (this.aggregates) {
        let attr = this.aggregates.find(item => {
          return item.name === key
        })

        if (attr) {
          return attr.value
        }
      }

      return null
    },

    formatValue(value) {
      if (value === null || value === '') {
        return '-'
      } else {
        return value
      }
    },

    updateModel(model) {
      this.model = model
      this.model.sort((a, b) => a.group_order - b.group_order)
    }
  }
}
</script>

<style scoped>
.block-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #7e8596;
  margin-bottom: 17px;
}

.block-container {
  background-color: #f8fafc;
  padding: 20px 20px 0 20px;
  margin-bottom: 16px;
}

.el-col.el-col-12 {
  margin-bottom: 20px;
}

.item-field-title {
  color: #a7acba;
  font-size: 14px;
  line-height: 22px;
  display: block;
}

>>> .label {
  font-size: 14px;
  line-height: 28px;
  color: #4b515f;
}

.select-attributes-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;
  background-color: #f8fafc;
}

.select-attributes-box span {
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: #4b515f;
  margin-bottom: 15px;
}

.empty-box {
  height: 20px;
  background-color: #f8fafc;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/FeaturedAttributes.vue